const Support = {
  name: 'Support',
  tel: '+(844) 434-672',
  links: [
    {
      title: 'Contact Us',
      href: '#'
    },
    {
      title: 'FAQ',
      href: '#'
    },
    {
      title: 'Feedback',
      href: '#'
    },
    {
      title: 'Live Chat',
      href: '#'
    },
    {
      title: 'My Account',
      href: '#'
    }
  ]
};
export default Support;
